const getDeep = (obj: unknown, path: string): unknown => path
  .split(/[.[\]]+/)
  .filter(Boolean)
  .reduce((o, k) => (o && (o as Record<string, unknown>)[k] !== undefined) ? (o as Record<string, unknown>)[k] : undefined, obj);

export default getDeep;